// 견적 폼에서 PC/모바일이 공통으로 사용하는 선택 항목 정의

export const ESTIMATE_TYPES = {
  GENERAL: '일반',
  COMMUTE: '통근',
};

export const ESTIMATE_TABS = [
  { value: ESTIMATE_TYPES.GENERAL, label: '일반 버스대절 견적' },
  { value: ESTIMATE_TYPES.COMMUTE, label: '통근·셔틀버스 견적' },
];

// 30분 단위 시간 목록 (05:00 ~ 04:30)
export const TIME_OPTIONS = (() => {
  const times = [];
  for (let i = 0; i < 48; i += 1) {
    const minutes = (5 * 60 + i * 30) % (24 * 60);
    const hh = String(Math.floor(minutes / 60)).padStart(2, '0');
    const mm = String(minutes % 60).padStart(2, '0');
    times.push(`${hh}:${mm}`);
  }
  return times;
})();

// 00:00 ~ 23:30 (통근·퇴근 시간용, 이른 새벽 출근도 있으므로 0시부터)
export const COMMUTE_TIME_OPTIONS = (() => {
  const times = [];
  for (let i = 0; i < 48; i += 1) {
    const hh = String(Math.floor(i / 2)).padStart(2, '0');
    const mm = i % 2 === 0 ? '00' : '30';
    times.push(`${hh}:${mm}`);
  }
  return times;
})();

export const PLACE_OPTIONS = [
  '서울', '경기', '인천', '강원', '충북', '충남', '대전', '세종',
  '전북', '전남', '광주', '경북', '경남', '대구', '울산', '부산', '제주',
];

export const TRAVEL_TYPES = ['일반여행', '관혼상제', '학교단체', '관공서', '기타단체'];

export const VEHICLE_TYPES = ['25인승 소형', '28인승 대형 리무진', '45인승 대형'];

export const VEHICLE_NUMBERS = [
  { value: '1', label: '1대' },
  { value: '2', label: '2대' },
  { value: '3', label: '3대' },
  { value: '4', label: '4대' },
  { value: '5', label: '5대' },
  { value: '6', label: '6대' },
  { value: '7', label: '7대' },
  { value: '8', label: '8대' },
  { value: '9', label: '9대' },
  { value: '10', label: '10대 이상' },
];

export const WAY_TYPES = ['왕복', '편도'];
export const PAYMENT_METHODS = ['현금', '카드'];
export const TAX_BILL_OPTIONS = ['발급', '발급안함'];

// 통근·셔틀 전용
export const WORK_TYPES = ['출근', '퇴근', '출근/퇴근', '1일 2교대', '1일 3교대', '기타'];
export const WORK_DAYS = ['주5일', '주6일', '매일', '평일+토요일', '기타'];
export const STOP_COUNTS = ['0', '1', '2', '3', '4', '5'];
